import React from 'react';
import { Paper } from '../../Paper';

import type { PaperProps } from '../../Paper/Paper.types';
import clsx from 'clsx';

/**
 * Wraps Accordion in Paper with additional styles
 */
export const AccordionWrapper = React.forwardRef<HTMLElement, PaperProps>(
  ({ children, className, ref: _ref, isFluid = true, ...props }, ref) => (
    <Paper
      ref={ref}
      isFluid={isFluid}
      className={clsx('hg-accordion__wrapper', className)}
      {...props}
    >
      {children}
    </Paper>
  )
);
AccordionWrapper.displayName = 'Accordion.Wrapper';
